// Tokens de layout compartilhados pela tela de detalhes de atendimento.
//
// O módulo de tickets nasceu com medidas fixas copiadas entre os styles.js:
// `padding: "0 50px"` de gutter e fontes de 10 a 13px. Num viewport de 375px
// esse gutter consome 100px — mais de um quarto da largura útil — e o texto
// fica abaixo do mínimo confortável de leitura.
//
// Centralizar aqui mantém as três variantes (HUBSOFT, IXC, Vero) e todos os
// subcomponentes com a mesma régua, e faz um ajuste de espaçamento valer para
// a tela inteira em vez de exigir a mesma edição em dez arquivos.

// Gutter horizontal da tela, em unidades de espaçamento do MUI (8px cada).
// Cresce com a largura disponível em vez de reservar 50px no celular.
export const gutterX = { xs: 2, sm: 3, md: 4, lg: 5 };

// Mesma régua, como padding pronto para `sx`.
export const paddingX = { px: gutterX };

// Escala tipográfica da tela. Nomes descrevem o papel, não o tamanho, para que
// um ajuste futuro não precise renomear nada.
export const fonts = {
  // Chips e marcadores compactos.
  chip: "0.6875rem",
  // Rótulos de campo e metadados.
  label: "0.8125rem",
  // Valores de campo e corpo de texto.
  body: "0.875rem",
  // Texto corrido longo (descrições, mensagens).
  reading: "0.9375rem",
  // Título de seção dentro do conteúdo.
  sectionTitle: "1rem",
  // Título principal do painel.
  panelTitle: { xs: "1rem", sm: "1.125rem" },
};

export const radius = {
  card: "14px",
  chip: "6px",
  panel: "16px",
};

// Altura mínima de alvo de toque. Abaixo disso o elemento fica difícil de
// acertar com o dedo em telas pequenas.
export const touchTarget = 40;
